import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from '../../network/APIEndpoints'
import { sitConfigQrAgentPortal } from '../../network/config'

const responseParser = (data: any) => {
  return data.response.map((item: any) => ({
    id: item.merchantId,
    name: item?.businessName ?? '',
    mobile: item?.merchantMobile?.number ?? '',
    status: item?.status ?? 'null',
    tid: item?.terminalId,
  }))
}

const getMidsQrListReq = (mobile: any, tokens: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.MidQRList,
    method: 'POST',
    config: sitConfigQrAgentPortal(tokens),
    body: {
      csoMobile: {
        countryCode: '91',
        number: mobile,
      },
    },
  }

  return executeRequest(request).then((data) => {
    if (data.data?.status === 'SUCCESS') {
      return responseParser(data.data)
    } else {
      throw data
    }
  })
}

export { getMidsQrListReq }
